import { WorkPeriod } from "src/app/models/mir-rule.model";

export function extraHtml(workPeriods: WorkPeriod[]) {
	// dynamically construct the work period presentation
	if (workPeriods.length === 0) return "";

	const dayOrder = ["Su", "M", "T", "W", "Th", "F", "S"];

	const toTimeString = (val: unknown): string => {
		const s =
			typeof val === "string"
				? val
				: val && typeof val === "object" && "label" in (val as any)
				? String((val as any).label)
				: String(val ?? "");
		return s === "00:00" || s === "00:00 AM" ? "" : s;
	};

	const cell = (inner: string, isHeader = false, isLastCol = false, redFont = false, isLastRow = false) => `
  <div style="
    box-sizing:border-box;
    ${isLastRow ? "" : "border-bottom:1px solid #333;"}
    ${isLastCol ? "" : "border-right:1px solid #333;"}
    display:flex; align-items:center; justify-content:center;
    padding:4px; min-height:40px;
    font-weight:${isHeader ? 700 : 400};
    ${redFont ? "color:#ce0100;" : ""}
  ">
    ${inner}
  </div>`;

	// Build one table per work period with per-table red-state headers
	const tables = workPeriods.map(wp => {
		const selectedDays = dayOrder.filter(d => wp.days?.[d]).join(", ");
		const start = toTimeString(wp.start);
		const end = toTimeString(wp.end);

		const header =
			cell("Days", true, false, !selectedDays) +
			cell("Start Time", true, false, !start) +
			cell("End Time", true, true, !end);

		// single row for this work period (mark as last row for bottom border removal logic)
		const row =
			cell(selectedDays || "", false, false, false, true) +
			cell(start, false, false, false, true) +
			cell(end, false, true, false, true);

		return `
      <div style="
        display:grid;
        grid-template-columns: repeat(3, 1fr);
        width:100%;
        border:1px solid #333;
        margin: 8px 0;
      ">
        ${header}
        ${row}
      </div>`;
	});

	return tables.join("");
}
